import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/unidades/getUnidadEmpleados.php';

export default function getUnidadEmpleados({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}